import { Box, Button } from '@agilize/components-core';
import React from 'react';
import { TooltipRenderProps } from 'react-joyride';
import { Container, Footer } from './TourContainer.styles';
import { TooltipProps } from './TourContainer.types';

const TourContainerTooltip = (props: TooltipProps) => {
  const { continuous, index, step, backProps, closeProps, primaryProps, tooltipProps, maxWidth } = props;

  return (
    <Container {...tooltipProps} maxWidth={maxWidth}>
      {step.title && <div>{step.title}</div>}
      <div>{step.content}</div>
      {!step.hideFooter && (
        <Footer>
          {!step.hideBackButton && index > 0 && (
            // @ts-ignore
            <Button type="button" {...backProps}>
              <div id="back">Voltar</div>
            </Button>
          )}
          {continuous && (
            // @ts-ignore
            <Button {...primaryProps}>
              <div id="next">Próximo</div>
            </Button>
          )}
          {!continuous && (
            // @ts-ignore
            <Button {...closeProps}>
              <div id="close">Ok</div>
            </Button>
          )}
        </Footer>
      )}
    </Container>
  );
};

export default TourContainerTooltip;
